<div kendoDialogContainer [hash]="id"></div>

<ng-template #dialogSaveCancelActions>
	<button printSectionId="print-section" ngxPrint class="btn btn-sigef-outline mr-auto" *ngIf="showPrintButton">{{printButtonText}}</button>
	<button class="btn btn-sigef mr-1" *ngIf="showEditButton" (click)="onEdit($event)">{{editButtonText}}</button>
	<button class="btn btn-sigef mr-1" *ngIf="showSaveButton" (click)="onSave($event)">{{saveButtonText}}</button>
	<button class="btn btn-sigef-secondary" *ngIf="showCancelButton" (click)="onCancel($event)">{{cancelButtonText}}</button>
</ng-template>
